import { render } from "./ProcessCard.vue?vue&type=template&id=7b0b8dfe&scoped=true&ts=true"
import script from "./ProcessCard.vue?vue&type=script&lang=ts"
export * from "./ProcessCard.vue?vue&type=script&lang=ts"

import "./ProcessCard.vue?vue&type=style&index=0&id=7b0b8dfe&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/rontend-vue_version_release-euau/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b0b8dfe"]])

export default __exports__